import React from 'react';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import { InspectionChecklist } from '../common';

export const MeasurementCheckList: React.FC<DynamicComponentProps> = (props: DynamicComponentProps) => {
    return (
        <InspectionChecklist 
            {...props}
            defaultHeader="Measurement Check"
            completionTranslationKey="measurement_check"
        />
    );
};